import React from "react";
import "./ComboCohortAddComponent.css";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../Loading/component";
import {
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  Typography,
  Box
} from "@mui/material";

export const ComboCohortAddComponent = (props) => {
  const { comboId } = useParams();
  const navigate = useNavigate();

  const arrowClick = (event) => {
    event.preventDefault();
    navigate(-1);
  };

  return (
    <div className="combo-cohort-container">
      <Sidebar />
      
      {props.loading ? (
        <LoadingSpinner />
      ) : (
        <div className="combo-cohort-content">
          <div className="combo-cohort-header">
            <button onClick={arrowClick} className="back-button">
              <img src={leftArrow} alt="Back" />
            </button>
            <h1>Combo Map</h1>
          </div>

          <div className="combo-cohort-form-container">
            <Box className="form-box">
              <form className="combo-cohort-form">
                <Typography variant="h6" component="label" gutterBottom className="form-label">
                  Cohort ID<span className="required-field">*</span>
                </Typography>
                <TextField
                  required
                  fullWidth
                  type="number"
                  variant="standard"
                  placeholder="Enter ID"
                  value={props.cohortId}
                  onChange={(e) => props.setCohortId(e.target.value)}
                  error={!!props.error.cohortId}
                  helperText={props.error.cohortId}
                  className="form-input"
                />

                <Typography variant="h6" component="label" gutterBottom className="form-label">
                  VM ID<span className="required-field">*</span>
                </Typography>
                <p className="vm-id-subtext">Select VM ID</p>
                <RadioGroup
                  value={props.vmIdOption}
                  onChange={(e) => props.setVmIdOption(e.target.value)}
                  className="radio-group"
                >
                  <FormControlLabel
                    value="all"
                    control={<Radio className="radio-button" />}
                    label="All"
                  />
                  <FormControlLabel
                    value="selectedOnly"
                    control={<Radio className="radio-button" />}
                    label="Selected Only"
                  />
                </RadioGroup>

                {props.vmIdOption === "selectedOnly" && (
                  <TextField
                    fullWidth
                    error={!!props.error.vmId}
                    helperText={props.error.vmId}
                    variant="standard"
                    placeholder="Enter vending machine list"
                    value={props.vmId}
                    onChange={(e) => props.setVmId(e.target.value)}
                    className="form-input"
                  />
                )}

                <Box className="submit-button-container">
                  <Button
                    onClick={props.handleApply}
                    variant="contained"
                    className="submit-button"
                  >
                    Apply
                  </Button>
                </Box>
              </form>
            </Box>
          </div>
        </div>
      )}
    </div>
  );
};